import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import PoOutlet from './PoOutlet'
import PO_ROUTE_URLS, { PO_BASE_URL } from './PoRoutes'
import PoDashboard from '../../Pages/PoTeam/pages/Dashboard/PoDashboard'
import MaterialMto from '../../Pages/PoTeam/pages/MaterialMto/MaterialMto'
import PreparePr from '../../Pages/PoTeam/pages/PreparePr/PreparePr'
import Inquiry from '../../Pages/PoTeam/pages/Inquiry/Inquiry'
import OfferComparision from '../../Pages/PoTeam/pages/OfferCom/OfferComparision'
import CounterOffer from '../../Pages/PoTeam/pages/CounterOffer/CounterOffer'
import Order from '../../Pages/PoTeam/pages/Order/Order'
import PoLogin from '../../Pages/PoTeam/auth/PoLogin'

const PoTeam = () => {
    return (
        <>
            <Routes>
                <Route path={PO_ROUTE_URLS.LOGIN} element={<PoLogin />} />

                <Route path={PO_BASE_URL} element={<PoOutlet />}>

                    <Route path={PO_ROUTE_URLS.HOME} element={<PoDashboard />} />
                    <Route path={PO_ROUTE_URLS.MTO} element={<MaterialMto />} />
                    <Route path={PO_ROUTE_URLS.PR} element={<PreparePr />} />
                    <Route path={PO_ROUTE_URLS.INQUIRY} element={<Inquiry />} />
                    <Route path={PO_ROUTE_URLS.OFF_COM} element={<OfferComparision />} />
                    <Route path={PO_ROUTE_URLS.CONTER_OFF} element={<CounterOffer />} />
                    <Route path={PO_ROUTE_URLS.ORDER_PLACE} element={<Order />} />

                </Route>
                <Route path={`${PO_BASE_URL}/*`} element={<Navigate to={PO_ROUTE_URLS.HOME} />} />
            </Routes>
        </>
    )
}

export default PoTeam